import { ArrowUpRight } from "lucide-react";
import type { NewsItem } from "@/types/news";

interface NewsCardProps {
	news: NewsItem;
}
const NewsCard = ({ news }: NewsCardProps) => {
	const authorImg = news.newsAuthorImgDark || news.newsAuthorImg;
	return (
		<a
			href={`/noticias/${news.id}`}
			className="group relative block rounded-3xl overflow-hidden hover:shadow-lg transition-shadow duration-300"
		>
			{/* Image container */}
			<div className="relative aspect-3/4 bg-muted">
				<img
					src={news.newsImg}
					alt={`Notícia: ${news.newsTitle}`}
					width={600}
					height={800}
					loading="lazy"
					decoding="async"
					className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
					onError={(e) => {
						e.currentTarget.src =
							"https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&q=80";
					}}
				/>

				{/* Overlay gradient */}
				<div className="absolute inset-0 bg-linear-to-t from-black via-black/80 to-black/40" />

				{/* Content overlay */}
				<div className="absolute inset-0 p-6 pb-8 flex flex-col justify-between">
					{/* Top section - Arrow button */}
					<div className="flex items-start justify-end">
						<div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/30 group-hover:bg-white/30 transition-colors">
							<ArrowUpRight className="w-5 h-5 text-white" />
						</div>
					</div>

					{/* Bottom section - Title, Author Image, Content, Date & Author */}
					<div className="space-y-2 pb-6">
						<img
							src={authorImg}
							alt={`Logo da fonte: ${news.newsAuthor}`}
							width={96}
							height={24}
							className="h-6 object-contain mb-3"
							onError={(e) => {
								e.currentTarget.style.display = "none";
							}}
						/>
						<h3 className="text-white text-base md:text-lg font-bold leading-tight tracking-tight line-clamp-3">
							{news.newsTitle}
						</h3>

						<p className="text-white/70 text-sm line-clamp-2 my-3">
							{news.newsContent}
						</p>
						<span className="text-xs text-accent-foreground">
							{news.newsDate}
						</span>
					</div>
				</div>
			</div>
		</a>
	);
};
export default NewsCard;
